module.exports = __webpack_public_path__ + "static/media/chatxd.865874ef.png";